var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"uncombat_knockout"}},[_vm._v("uncombat_knockout")])
}
var staticRenderFns = []

export { render, staticRenderFns }